import React from "react";
// import MainAuth from "./../";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import EditProfile from "src/components/panel/profile/EditProfile";

const EditProfileView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("edit_profile_tab")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("edit_profile_title")}
          subtitle={t("edit_profile_subtitle")}
        />
        <EditProfile />
      </Sidebar>
    </>
  );
};

export default EditProfileView;
